module.exports = __webpack_public_path__ + "media/images/glass-services-3-b885de25863580b7ef9e529fa9ad9d51.jpg";